import { render, staticRenderFns } from "./CodeStatistcs.vue?vue&type=template&id=2489c1f1&scoped=true"
import script from "./CodeStatistcs.vue?vue&type=script&lang=js"
export * from "./CodeStatistcs.vue?vue&type=script&lang=js"
import style0 from "./CodeStatistcs.vue?vue&type=style&index=0&id=2489c1f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2489c1f1",
  null
  
)

export default component.exports